module.exports = __webpack_public_path__ + "img/cup-white.debc6b87.svg";